import { Component, OnInit, Input, OnChanges, SimpleChange, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';

import { AccountTypePipe } from "../account-type.pipe";

import { Domain as WebsideDomain } from "../../../../lib/Domain/Webside";
@Component({
  selector: 'app-account-edit',
  templateUrl: './account-edit.component.html',
  styleUrls: ['./account-edit.component.css']
})
export class AccountEditComponent implements OnInit {
  @Output() Save = new EventEmitter();
  @Output() Close = new EventEmitter();
  @Input() Item: WebsideDomain.IAccount = undefined;
  @Input() Index: number = 0;
  public modalTitle = "建立新用戶";
  public userTypelists: any[] = AccountTypePipe.getType();
  public cfmpassword = "";
  public errMsg = "";
  private isCreated = true;

  constructor() { }


  OnSubmit() {
    if (this.isCreated) {
      if (this.Item.password !== this.cfmpassword) {
        this.errMsg = "密碼與確認密碼不相符"
        this.Item.password = "";
        this.cfmpassword = ""
        return;
      }
    }
    if (this.Save) {
      this.Save.emit({
        Item: this.Item, isCreated: this.isCreated, callback: (erro:Error) => {
          if (erro) {
            this.errMsg = erro.message;
          } else {
            this.OnClose();
          }

        }
      });

    }
  }
  OnClose() {
    if (this.Close) {
      this.Close.emit();
    }
  }


  ngOnInit() {

  }

  ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
    if (changes['Item'] && this.Item) {
      this.isCreated = false;
      this.modalTitle = `編輯用戶`;
      this.Item = {
        uuid: this.Item.uuid,
        username: this.Item.username,
        usertype: this.Item.usertype,
        email: this.Item.email,
        password: this.Item.password,
        createdate: this.Item.createdate,
        phone: this.Item.phone,
        isemailverification: this.Item.isemailverification,
        isactived: this.Item.isactived,
        isbanned: this.Item.isbanned,
        passwordrertycount: this.Item.passwordrertycount,
        permission: this.Item.permission,
        loginlogs:this.Item.loginlogs,
        operationlogs:this.Item.operationlogs
      };

    } else if (changes['Item'].currentValue === undefined) {
      this.isCreated = true;
      this.modalTitle = "建立新用戶";
      this.Item = {
        uuid: "",
        username: "",
        usertype: 0,
        email: "",
        password: "",
        createdate: new Date(),
        phone: "",
        isemailverification: false,
        isactived: true,
        isbanned: false,
        passwordrertycount: 0,
        permission: 0,
        loginlogs:[],
        operationlogs:[],
      };
    }
  }

}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/account-edit/account-edit.component.ts